import type { CatalogItem } from '~/models/common'

export const userLooking: CatalogItem[] = [
  {
    label: 'AR / VR',
    value: 1,
  },
  {
    label: 'Art',
    value: 2,
  },
  {
    label: 'Sound',
    value: 22,
  },
  {
    label: 'Consultancy',
    value: 3,
  },
  {
    label: 'Development(Blockchain)',
    value: 4,
  },
  {
    label: 'Development(mobile)',
    value: 5,
  },
  {
    label: 'Development(PC / console)',
    value: 6,
  },
  {
    label: 'Distribution',
    value: 7,
  },
  {
    label: 'Game Testing',
    value: 8,
  },
  {
    label: 'Investment',
    value: 9,
  },
  {
    label: 'Licensing',
    value: 10,
  },
  {
    label: 'Localisation',
    value: 11,
  },
  {
    label: 'Marketing',
    value: 12,
  },
  {
    label: 'Media Coverage',
    value: 13,
  },
  {
    label: 'Monetization',
    value: 14,
  },
  {
    label: 'Publishing(PC)',
    value: 15,
  },
  {
    label: 'Publishing(mobile)',
    value: 16,
  },
  {
    label: 'Tools & Services',
    value: 17,
  },
  {
    label: 'User Acquisition',
    value: 18,
  },
  {
    label: 'Game Stores',
    value: 19,
  },
  {
    label: 'Recruitment',
    value: 21,
  },
  {
    label: 'Analytics',
    value: 35,
  },
  {
    label: 'Developer',
    value: 23,
  },
  {
    label: 'Platform',
    value: 24,
  },
  {
    label: 'Advertising',
    value: 25,
  },
  {
    label: 'Graphics',
    value: 26,
  },
  {
    label: 'Billing',
    value: 27,
  },
  {
    label: 'Investor',
    value: 28,
  },
  {
    label: 'Press',
    value: 29,
  },
  {
    label: 'Hosting',
    value: 30,
  },
  {
    label: 'Retargeting',
    value: 31,
  },
  {
    label: 'HTML5 Games',
    value: 32,
  },
  {
    label: 'Mobile Games',
    value: 33,
  },
  {
    label: 'PC / Console Games',
    value: 34,
  },
  {
    label: 'Other',
    value: 20,
  },
  {
    label: 'UA Creatives',
    value: 36,
  },
  {
    label: 'Game Design',
    value: 37,
  },
]
